import "babel-polyfill";
import Vue from 'vue'
import Router from 'vue-router'

import TabPatient from '@/components/patients/TabPatient'
import PagePatientCreate from '@/components/patients/PagePatientCreate'
import PagePatientDetails from '@/components/patients/PagePatientDetails'
import ActionPlan from '@/components/content/TabActionPlan'
import LessonPlan from '@/components/content/TabLessonPlan'
import TabAssessment from '@/components/assessment/TabAssessment'
import PageAssessment from '@/components/assessment/PageAssessment'
import PageLessonPlanCreate from '@/components/content/PageLessonPlanCreate'
import PageActionPlanCreate from '@/components/content/PageActionPlanCreate'
import LogInPage from '@/components/LogInPage'
import GetStarted from '@/components/help/PageGetStarted'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LogInPage,
      props: true
    },
    {
      path: '/',
      redirect: { name: 'TabPatient'}
    },
    {
      path: '/patient',
      name: 'TabPatient',
      component: TabPatient
    },
    {
      path: '/patient/new',
      name: 'PagePatientCreate',
      component: PagePatientCreate
    },
    {
      path: '/patient/:patientid',
      name: 'PagePatientDetails',
      component: PagePatientDetails,
      props: true
    },
    {
      path: '/action',
      name: 'ActionPlan',
      component: ActionPlan
    },
    {
      path: '/lesson',
      name: 'LessonPlan',
      component: LessonPlan
    },
    {
      path: '/action/new',
      name: 'PageActionPlanCreate',
      component: PageActionPlanCreate,
      props: true
    },
    {
      path: '/action/:actionid',
      name: 'EditActionPlan',
      component: PageActionPlanCreate,
      props: true
    },
    {
      path: '/lesson/new',
      name: 'PageLessonPlanCreate',
      component: PageLessonPlanCreate,
      props: true
    },
    {
      path: '/lesson/:lessonid',
      name: 'EditLessonPlan',
      component: PageLessonPlanCreate,
      props: true
    },
    // {
    //   path: '/assessment',
    //   name: 'Assessment',
    //   component: TabAssessment
    // },
    // {
    //   path: '/assessment/:checkpoint',
    //   name: 'PageAssessment',
    //   component: PageAssessment,
    //   props: true
    // },
    {
      path: '/help',
      name: 'GetStarted',
      component: GetStarted
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js